import { render, staticRenderFns } from "./PostSection.vue?vue&type=template&id=01b159a3&scoped=true&"
import script from "./PostSection.vue?vue&type=script&lang=js&"
export * from "./PostSection.vue?vue&type=script&lang=js&"
import style0 from "./PostSection.vue?vue&type=style&index=0&id=01b159a3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b159a3",
  null
  
)

export default component.exports